import { TEAM_PAGE } from './actionTypes';

const initialState = {
  teams: null,
  loading: {
    teams: false,
  },
  error: {
    teams: null,
  },
};

const TeamReducer = (state = initialState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    case TEAM_PAGE.TEAM_PAGE_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, teams: true },
        error: { ...state.error, teams: null },
      };
    case TEAM_PAGE.TEAM_PAGE_SUCCESS:
      return {
        ...state,
        teams: payload,
        loading: { ...state.loading, teams: false },
      };
    case TEAM_PAGE.TEAM_PAGE_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, teams: false },
        error: { ...state.error, teams: error },
      };
    default:
      return state;
  }
};

export default TeamReducer;
